import { createStyles, withStyles } from '@mui/styles';
import { getCompanyStyles } from 'lib/api/express/company';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { AuthState, logout } from 'services/redux/authSlice';
import { ClientConfigState } from 'services/redux/clientConfigSlice';
import { setConfig } from 'services/redux/clientConfigSlice';

import Footer from './Footer';
import SideBar from './SideBar';

const styles = createStyles({
  layoutWrapper: {
    display: 'flex',
    height: '100vh',
  },
  layout: {
    width: '100%',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '0px 20px',
    backgroundColor: '#F8FAFC',
    boxSizing: 'border-box',
  },
  layoutContent: {
    flexGrow: 1,
  },
  loading: {
    opacity: 0.6,
    pointerEvents: 'none',
  },
});

interface Props {
  children: React.ReactNode;
  classes: Record<keyof typeof styles, string>;
}

const PruffConnectLayout = (props: Props) => {
  const dispatch = useDispatch();
  const { children, classes } = props;
  const auth = useSelector((state: { auth: AuthState }) => state.auth);

  const domain = window.location.hostname;
  const subdomain = domain.split('.')[0];
  const finalClientId = subdomain;
  const expressConfig = useSelector(
    (state: { clientConfiguration: ClientConfigState }) =>
      state.clientConfiguration.configs,
  );

  const isInCorrectPortal = async () => {
    if (auth.isAuthenticated && auth?.user?.clientId !== finalClientId) {
      dispatch(logout());
      return false;
    }
    return true;
  };

  const setUpClientConfiguration = async () => {
    try {
      const correctPortal = await isInCorrectPortal();
      if (!correctPortal) return;
      if (!finalClientId) return;
      if (!expressConfig || expressConfig.finalClientId !== finalClientId) {
        const response = await getCompanyStyles(finalClientId);
        dispatch(setConfig({ ...response, finalClientId }));
      }
    } catch (error) {
      console.error('error', error);
    }
  };

  useEffect(() => {
    void setUpClientConfiguration();
  }, []);

  return (
    <div className={classes.layoutWrapper}>
      {auth.isAuthenticated && <SideBar />}
      <div className={classes.layout}>
        <div className={classes.layoutContent}>{children}</div>
        <Footer />
      </div>
    </div>
  );
};

export default withStyles(styles)(PruffConnectLayout);
